document.addEventListener("DOMContentLoaded", () => {
  const variantsContainers = document.querySelectorAll('.psuedo-variants--container')
    if(variantsContainers){
      variantsContainers.forEach(container => {
        const slider = container.querySelector('.psuedo-variants')
        const tag = container.getAttribute('data-group-tag')
        const currentProduct = container.getAttribute('data-current-product')
        if(tag){
          jQuery.ajax({
            url: 'https://evolveinsideout.com/soccer-warehouse-api.php?tag=' + tag,
            complete: data => {
              if((data?.responseJSON?.data?.products?.edges ?? []).length > 0){
                data.responseJSON.data.products.edges.forEach(product => {
                  if(product.node.onlineStoreUrl && product?.node?.images?.edges?.length && product.node.id.indexOf(currentProduct) == -1){
                    const template = container.querySelector('.psuedo-variation--template').cloneNode(true)
                    template.href = product.node.onlineStoreUrl
                
                    const image = template.querySelector('img');
                    image.src = product.node.images.edges[0].node.src;
                    const productTitle = product.node.title;
                
                    template.classList.remove('psuedo-variation--template')
                    template.classList.add('psuedo-variation')
                    template.style.display = ""
                    slider.append(template)
                
                    const variantIndex = Array.from(container.querySelectorAll('.psuedo-variation')).indexOf(template) + 1;
                    const ariaLabel = `${productTitle} variant ${variantIndex}`;
                    image.setAttribute('aria-label', ariaLabel);
                  }
                })

                container.querySelector('.psuedo-variation--template').remove()

                jQuery(slider).slick({
                  slidesToShow: 6,
                  prevArrow: '<button type="button" class="slick-prev"><</button>',
                  nextArrow: '<button type="button" class="slick-next">></button>',
                  responsive: [
                    { breakpoint: 1180, settings: { slidesToShow: 5 }},
                    { breakpoint: 960, settings: { slidesToShow: 4 }},
                    { breakpoint: 799, settings: { slidesToShow: 6 }},
                    { breakpoint: 690, settings: { slidesToShow: 5 }},
                    { breakpoint: 500, settings: { slidesToShow: 4 }},
                    { breakpoint: 390, settings: { slidesToShow: 3 }},
                  ]
                })

                container.style.display = ""
              }
            }
          })
        }
      })
    }
})